require('./hireCardViaTStep4.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const CardLegalViewerModal = require('components/cards/cardLegalViewerModal/cardLegalViewerModal');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const ContactCenterNewValidationCards = require('components/hire/contactCenterValidationCards/contactCenterNewValidationCards');

// @constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    CREDIT_CARD_STANDARD_VIA_T,
    CREDIT_CARD_SUBTYPE_VIA_T,
    CREDIT_CARD_TYPE_VIA_T,
    EURO_SYMBOL,
    EURO_TEXT,
    FOURTH_STEP,
    HYPHEN
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { VIA_T_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    CONTRACT_VIAT,
    messages: {CONTRACT_VIAT_AND_GDPR}
} = require('constants/operationTypes');
const { VIA_T_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
const { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const FILENAMES = require('constants/mortgageRequestFileNames');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class HireCardViaTStep4 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)
        this.state = {
            precontractualMailProductInfo: {
                productName: VIA_T_CARD_PRODUCT_NAME,
                producto: CREDIT_CARD_TYPE_VIA_T,
                standard: CREDIT_CARD_STANDARD_VIA_T,
                subproducto: CREDIT_CARD_SUBTYPE_VIA_T
            }
        };
    }

    componentDidMount() {
        const { sendPrecontractualDocumentMail, showIneAndRevolving } = this.props;
        const { precontractualMailProductInfo } = this.state;

        if (!showIneAndRevolving) {
            sendPrecontractualDocumentMail(precontractualMailProductInfo);
            if (!__CONTACT_CENTER__) {
                //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
                this.props.setTermsAndCondsText('hireCardViaT-hireCardViaT_confirmationStepAgreementText');
            }
        }
    }

    onHandleChangeCheckBox = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FOURTH_STEP)
    }

    onHandleChangeCheckBoxCC = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FOURTH_STEP)
    }
    
    buildLegalConfirmationSection(showRevolvingDocument, amount) {
        const {
            contractName,
            immHireCardViaT,
            sendMailParams,
            showIneAndRevolving,
            onHandleChangeCheckBoxCC,
            immFlagBasedFeatures,
            processEmail
        } = this.props;
        const { precontractualMailProductInfo } = this.state;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = immHireCardViaT.getIn(['steps', FOURTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardViaT-step3CheckboxText" />; // Re-uses step 3 labels because they have to be the same
        const agreementErrorMsg = formatText('hireCardViaT-step3CheckboxErrorMsg'); // Re-uses step 3 labels because they have to be the same
        const documentINE = immHireCardViaT.get('documentINE')
        const documentPolicy = immHireCardViaT.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy

        if (newCardsFF) {
            return (
                <ContactCenterNewValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    isContractingProcess
                    immStep={immStep}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={processEmail}
                    immHireCardOpenCredit={immHireCardViaT}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        }else{
            return (
                <ContactCenterValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    isContractingProcess
                    immStep={immStep}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={processEmail}
                    immHireCardOpenCredit={immHireCardViaT}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        }
    }

    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButtonPolicy } = this.props

        checkRadioButtonPolicy(value === 'yes' ? true : false)
    }

    buildSummary() {
        const { immHireCreditLimit, immHirePaymentMethod } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardViaT-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardViaT-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardViaT-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL: '%';
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${formatAmount(immHirePaymentMethod.get('value'), getLanguage(), 0)} ${paymentMethodSymbol}`;

        const addressValue = immShippingAddress.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

        return (
            <div className="hire-card-via-t-step-four__summary row">
                <div className="col-xs-3 print-label">
                    <div className="hire-card-via-t-step-four__summary-label">
                        <FormattedText value="hireCardViaT-summarySelectedLimit" />
                    </div>
                    <div className="hire-card-via-t-step-four__summary-value--highlight">
                        <OneLineSymbolAmount
                            amountObject={limitObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(limitObj, true)}
                            trimDecimals={true}
                        />
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="hire-card-via-t-step-four__summary-label">
                        <FormattedText value="hireCardViaT-summaryPaymentMethod" />
                    </div>
                    <div className="hire-card-via-t-step-four__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
                <div className="col-xs-5 print-label">
                    <div className="hire-card-via-t-step-four__summary-label">
                        <FormattedText value="hireCardViaT-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-via-t-step-four__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    blockInfo() {
        const { operativeName } = this.props;
        return (

            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check block-info" hasCheckbox>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>

            </BlockInfo>
        );
    }

    openPdfInNewTab(documentKey) {
        const { immHireCardViaT} = this.props;
        const document = immHireCardViaT.get(documentKey);
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
    }

    handleOpenPdfINENewTab() {
        this.openPdfInNewTab('documentINE');
    }

    handleOpenPdfDIRNewTab() {
        this.openPdfInNewTab('documentDIR');
    }

    buildPdfLink() {
        const { immHireCardViaT } = this.props;
        const documentDIR = immHireCardViaT.get('documentDIR');
        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed contract-payrollLoan-readed">

                        <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfINENewTab()}>
                            <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                        </button>
                        <span><i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                        </span>
                    </div>
                    {documentDIR && (
                        <div className="contract-actions-readed contract-payrollLoan-readed">
                            <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfDIRNewTab()}>
                                <FormattedText value={'hireCreditCard-documentNameDir'} />
                            </button>
                            <span>
                                <i className="signature-pattern-code-input__icon icon icon-check" />
                                <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                            </span>
                        </div>
                    )}
                </div>

            </>
        )
    }

    handleOnPrint() {
        const { hireCardViaTprintDocument, immHireCardViaT, hireCardViaTprintDocumentPolicy } = this.props;
        const documentINE = immHireCardViaT.get('documentPolicy');


        if (documentINE) {
            const base64 = documentINE;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            isPrintOfficeMode() ? hireCardViaTprintDocumentPolicy() : hireCardViaTprintDocument()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    
    handleDocumentReaded() {
        const { cardsConfimationScrollDownPolicy } = this.props;
        cardsConfimationScrollDownPolicy();
    }

    handleDownloadPdf() {
        const { immHireCardViaT } = this.props;

        const documentINE = immHireCardViaT.get('documentPolicy');
        const base64 = documentINE;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = formatText(`hireCardOpenCreditStepPolicy-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }

    buildViewer() {
        const { immHireCardViaT } = this.props;

        const documentINE = immHireCardViaT.get('documentPolicy');
        if (documentINE) {
            let title = isPrintOfficeMode() ? formatText(`hireCardOpenCreditStepPolicy-titlePdfOffice`) : formatText(`hireCardOpenCreditStepPolicy-titlePdfWP`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }

    blockInfoOffice() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check hire-card-open-credit-step-five__block-info-officine" hasCheckbox>
                <strong><FormattedText value="hireCardOpenCreditStep5-blockInfoOficineTitle" /></strong>
                <br />
                <br />
                <FormattedText value="hireCardOpenCreditStep5-blockInfoOficineSubTitle" />
            </BlockInfo>
        );
    }

    render() {
        const { immFlagBasedFeatures, immHireCardViaT, immHireCreditLimit, operativeName, immPdfData, showIneAndRevolving, handleAgreementCheckboxChange, immHirePaymentMethod} = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const { precontractualMailProductInfo } = this.state;
        const immStep = immHireCardViaT.getIn(['steps', FOURTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardViaT-hireCardViaT_confirmationStepAgreementText" />;
        const agreementChecked = (__CONTACT_CENTER__ && !showIneAndRevolving ? true : immStep.get('agreementChecked'));
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardViaT-step3CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const operationProcessId = immHireCardViaT.get('operationProcessIdInitPolicy')
        const multipleSignaturePatternParams = [{
            serviceCode: CONTRACT_VIAT
        },{
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName('print-title', 'hire-card-via-t-step-four__title')
        const hireCardSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-via-t-step-four__subtitle')
        const preContractDocumentInfo = getCardsPreContractPdfData()['via-T'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;
        const paymentMethodType = immHirePaymentMethod.get('type');
        const showRevolvingDocument = paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE;
        const amount = immHireCreditLimit.get('creditLimit');
        const legalConfirmationSection = this.buildLegalConfirmationSection(showRevolvingDocument, amount);
        const blockInfo = isPrintOfficeMode() && this.blockInfo();
        const agreeIneCheckbox = immHireCardViaT.get('agreeIneCheckbox')
        const pdfLink = newCardsFF ? this.buildPdfLink() : null
        const PDFDcocument = this.buildViewer();
        const blockInfoOffice = isPrintOfficeMode() ? this.blockInfoOffice() : null;
        if(!pdfError && !showIneAndRevolving) {
            agreementCheckboxContent = (
                <div className="hire-card-via-t-step-four__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardViaTAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={multipleSignaturePatternParams}
                    multiOTPMessageCode={CONTRACT_VIAT_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                />
            )
        }

        if(agreeIneCheckbox) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={multipleSignaturePatternParams}
                    multiOTPMessageCode={CONTRACT_VIAT_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}
                />
            )
        }

        if (newCardsFF) {
            if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
                return (
                <article className="hire-card-via-t-step-four">
                    <FormattedText
                        className={hireCardTitleClassName}
                        value="hireCardViaT-step3Title"
                    />
                    <FormattedText
                        className={hireCardSubTitleClassName}
                        value="hireCardViaT-step3Subtitle"
                    />
                    <br />
                    {summaryContent}
                    <OKConsents placementId={VIA_T_GDPR_PID} />
                    <div className="hire-card-via-t-step-four__pdf-viewer-container">
                        {pdfLink}
                        <br />
                        <div className="hire-card-open-credit-step-five__summary-label">
                            <FormattedText value="hireCardOpenCredit-infoLink" />
                        </div>
                        <br />
                        {blockInfoOffice}
                        <br />
                        {PDFDcocument}                            
                    </div>
                    {GDPRSignaturePatternContent}
                </article>
                );
            }else{
                return (
                    <article className="hire-card-via-t-step-four">
                        <FormattedText
                            className={hireCardTitleClassName}
                            value="hireCardViaT-step3Title"
                        />
                        <FormattedText
                            className={hireCardSubTitleClassName}
                            value="hireCardViaT-step3Subtitle"
                        />
                        {blockInfo}
                        <br />
                        {summaryContent}
                        <OKConsents placementId={VIA_T_GDPR_PID} />
                        <WebappRender>
                            <div className="hire-card-via-t-step-four__pdf-viewer-container">
                                {pdfLink}
                                <br />
                                <div className="hire-card-open-credit-step-five__summary-label">
                                    <FormattedText value="hireCardOpenCredit-infoLink" />
                                </div>
                                <br />
                                {PDFDcocument}
                                <br />
                            </div>
                        </WebappRender>
                        {agreementCheckboxContent}
                        <ContactCenterRender>
                            {showIneAndRevolving ?
                                legalConfirmationSection
                                :<ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                            }
                        </ContactCenterRender>
                        {GDPRSignaturePatternContent}
                    </article>
                    ); 
            }
        }else{
            return (
                <article className="hire-card-via-t-step-four">
                    <FormattedText
                        className={hireCardTitleClassName}
                        value="hireCardViaT-step3Title"
                    />
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={formatText(operativeName)}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <FormattedText
                        className={hireCardSubTitleClassName}
                        value="hireCardViaT-step3Subtitle"
                    />
                    {summaryContent}
                    <OKConsents placementId={VIA_T_GDPR_PID} />
                    <WebappRender>
                        <div className="hire-card-via-t-step-four__pdf-viewer-container">
                            {showIneAndRevolving ?
                                <CardLegalViewerModal
                                    amount={amount}
                                    agreeCheckboxRevol={agreementChecked}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    isContractingProcess
                                    precontractualMailProductInfo={precontractualMailProductInfo}
                                    showRevolvingDocument={showRevolvingDocument}
                                />
                                : <PreContractualDocumentViewer
                                    preContractDocumentInfo={preContractDocumentInfo}
                                    titleKey="preContractDocument_pdfTitleINE"
                                />
                            }
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    <ContactCenterRender>
                        {showIneAndRevolving ?
                            legalConfirmationSection
                            :<ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        }
                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </article>
                ); 
        }
    }
}

HireCardViaTStep4.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immHireCardViaT: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPdfDownloadData: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    requestPDFDownload: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardViaTStep4;
